AFRAME.registerComponent('left-panel-2', {
    schema: {},

    init: function () {

        this.themeMode = 'Dark'
        this.themeMode = 'Dark'
        const mainSettings = getCacheItem('mainSettings');
        if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
            this.themeMode = mainSettings.themeMode;
        } else {
            const parsed = getCacheItem('configureControlSettings');
            if (parsed && (parsed.themeMode === 'Light' || parsed.themeMode === 'Dark')) {
                this.themeMode = parsed.themeMode;
            }
        }
        this.mainContentColor = '#fff'
        this.bgPanelLight = this.el.querySelector('.background-panel-light')
        this.bgPanelDark = this.el.querySelector('.background-panel-dark')
        this.bgModel = this.el.querySelector('.bg-model')
        this.applyTheme()

        console.log('configure-control initialized')
        this.scene = document.querySelector('a-scene');

        this.screen1 = this.el.querySelector('#news-screen-1');
        this.screen2 = this.el.querySelector('#news-screen-2');
        this.currentNews = null

        this.headerElementS1 = this.el.querySelector('#news-screen-1 .left-panel-2-header');
        this.headerElementS2 = this.el.querySelector('#news-screen-2 .left-panel-2-header');
        this.contentElementS2 = this.el.querySelector('#news-screen-2  .left-panel-2-content');
        if (!this.headerElementS1 || !this.headerElementS2 || !this.contentElementS2) return
        this.contentElementS1 = this.el.querySelector('#news-screen-1  .left-panel-2-content');
        if (!this.contentElementS1) return
        this.createNewsPanel();

        this.lastNewsList = []
        this.scene.addEventListener('update-news-type-2', this.updateNewsType.bind(this));
        this.scene.addEventListener('update-news-list-2', this.updateNewsList.bind(this));
        this.scene.addEventListener('theme-changed', this.updateTheme.bind(this));

        this.scene.addEventListener('chart-type-changed', (e) => {
            const action = e.detail?.action;
            if (action && action !== 'watchlist-reports') {
                this.setFilter('general');
                this.scene.emit('news-filter-changed', { filter: 'general' });
            }
        });
    },

    applyTheme: function () {
        console.log('applyTheme', this.themeMode)
        if (this.themeMode === 'Dark') {
            if (this.bgPanelLight) this.bgPanelLight.setAttribute('visible', false);
            if (this.bgPanelDark) this.bgPanelDark.setAttribute('visible', true);
            if (this.bgModel) this.bgModel.setAttribute('visible', 'true')

            this.mainContentColor = '#fff';
        } else {
            if (this.bgPanelDark) this.bgPanelDark.setAttribute('visible', false);
            if (this.bgPanelLight) this.bgPanelLight.setAttribute('visible', true);

            if (this.bgModel) this.bgModel.setAttribute('visible', 'false')

            this.mainContentColor = '#111';
        }
    },


    createNewsPanel: function () {
        this.titleTextS1 = document.createElement('a-text');
        this.titleTextS1.setAttribute('value', 'News');
        this.titleTextS1.setAttribute('color', this.mainContentColor);
        this.titleTextS1.setAttribute('scale', '0.25 0.25 0.25');
        this.titleTextS1.setAttribute('anchor', 'left');
        this.titleTextS1.setAttribute('position', `0 0 0.01`)
        this.contentElementS1.appendChild(this.titleTextS1);

        const filterContainer = document.createElement('a-entity');
        filterContainer.setAttribute('position', '0.1 -0.06 0.02');
        
        this.generalBtn = document.createElement('a-entity');
        this.generalBtn.setAttribute('ui-button', {
            label: 'Business',
            width: 0.35,
            height: 0.12,
            depth: 0.02,
            radius: 0.015,
            colorScheme: 'primary',
            selected: true,
            type: 'rounded-box',
            fontSize: 0.05
        });
        this.generalBtn.setAttribute('position', '-0.2 0 0');
        this.generalBtn.addEventListener('click', () => {
             this.setFilter('general');
             this.scene.emit('news-filter-changed', { filter: 'general' });

            if (window.gtag) gtag('event', 'VR_LeftPanel_GeneralBusiness');
        });
        filterContainer.appendChild(this.generalBtn);

        this.watchlistBtn = document.createElement('a-entity');
        this.watchlistBtn.setAttribute('ui-button', {
            label: 'Watchlist',
            width: 0.35,
            height: 0.12,
            depth: 0.02,
            radius: 0.015,
            colorScheme: 'primary',
            type: 'rounded-box',
            fontSize: 0.05
        });
        this.watchlistBtn.setAttribute('position', '0.25 0 0');
        this.watchlistBtn.addEventListener('click', () => {
             this.setFilter('watchlist');
             this.scene.emit('news-filter-changed', { filter: 'watchlist' });

            if (window.gtag) gtag('event', 'VR_LeftPanel_WatchlistButton');
        });
        filterContainer.appendChild(this.watchlistBtn);
        
        this.headerElementS1.appendChild(filterContainer);

        this.el.sceneEl.addEventListener('set-news-filter-ui', (evt) => {
            if (evt.detail && evt.detail.filter) {
                this.setFilter(evt.detail.filter);
            }
        });

        const backButtonContainer = document.createElement('a-entity');
        backButtonContainer.setAttribute('position', `-0.5 -0.1 0.01`);

        const backButton = document.createElement('ui-button');
        backButton.setAttribute('type', 'rounded-box');
        backButton.setAttribute('image', '#back-button');
        backButton.setAttribute('width', 0.1);
        backButton.setAttribute('height', 0.1);
        backButton.setAttribute('depth', 0.01);
        backButton.setAttribute('radius', 0.02);
        backButton.setAttribute('color-scheme', 'primary');
        backButtonContainer.appendChild(backButton);

        this.headerElementS2.appendChild(backButtonContainer);
        backButton.addEventListener('click', () => {
            this.screen1.setAttribute('visible', 'true');
            this.screen1.setAttribute('position', '0 0 0.02');
            this.screen2.setAttribute('visible', 'false');
            this.screen2.setAttribute('position', '0 6 0');
        })

        console.log('title2', this.mainContentColor)
        const title2 = document.createElement('a-text');
        title2.setAttribute('value', 'News');
        title2.setAttribute('color', this.mainContentColor);
        title2.setAttribute('scale', '0.25 0.25 0.25');
        title2.setAttribute('anchor', 'left');
        title2.setAttribute('position', `0 -0.1 0.001`)
        this.headerElementS2.appendChild(title2);

        const typeEl = document.createElement('a-text');
        typeEl.setAttribute('id', 'news-type-text-2')
        typeEl.setAttribute('value', 'BUSINESS');
        typeEl.setAttribute('color', this.mainContentColor)
        typeEl.setAttribute('scale', '0.15 0.15 0.15');
        typeEl.setAttribute('anchor', 'left');
        // typeEl.setAttribute('fill-opacity', 0.5);
        typeEl.setAttribute('opacity', 0.5);
        typeEl.setAttribute('position', `0 -0.05 0.001`)
        this.contentElementS2.appendChild(typeEl);

        const date2 = document.createElement('a-text');
        date2.setAttribute('id', 'news-date-text-2')
        date2.setAttribute('color', this.mainContentColor)
        date2.setAttribute('value', '9/30/2025');
        // date2.setAttribute('font-size', 0.03);
        date2.setAttribute('scale', '0.15 0.15 0.15');
        date2.setAttribute('anchor', 'right');
        date2.setAttribute('align', 'right');
        // date2.setAttribute('opacity', 0.5);
        date2.setAttribute('fill-opacity', 0.5);
        date2.setAttribute('position', `1.1 -0.05 0.001`)
        this.contentElementS2.appendChild(date2);

        const newsTitle2 = document.createElement('a-text');
        newsTitle2.setAttribute('id', 'news-title-text-2')
        newsTitle2.setAttribute('color', this.mainContentColor)
        newsTitle2.setAttribute('value', 'Chamber of indigenous Business & Investors chastises Fourth Estate for poor journalistic, unethical investigation on NLA-KGL deal');
        newsTitle2.setAttribute('font-size', 0.05);
        newsTitle2.setAttribute('scale', '0.25 0.25 0.25');
        newsTitle2.setAttribute('anchor', 'left');
        newsTitle2.setAttribute('baseline', 'top');
        newsTitle2.setAttribute('position', `0 -0.1 0.001`)
        newsTitle2.setAttribute('max-width', 1.1)
        newsTitle2.setAttribute('width', 4.2)
        newsTitle2.setAttribute('wrapCount', 33.6)
        newsTitle2.setAttribute('line-height', 60)
        this.contentElementS2.appendChild(newsTitle2);

        const source2 = document.createElement('a-text');
        source2.setAttribute('id', 'news-source-text-2')
        source2.setAttribute('color', this.mainContentColor)
        source2.setAttribute('value', 'By modernghana');
        source2.setAttribute('font-size', 0.04);
        source2.setAttribute('scale', '0.2 0.2 0.2');
        source2.setAttribute('anchor', 'left');
        source2.setAttribute('baseline', 'top');
        // source2.setAttribute('fill-opacity', 0.5);
        source2.setAttribute('opacity', 0.5);
        source2.setAttribute('position', `0 -0.3 0.001`)
        source2.setAttribute('max-width', 1.1)
        this.contentElementS2.appendChild(source2);

        const description2 = document.createElement('a-text');
        description2.setAttribute('id', 'news-description-text-2');
        description2.setAttribute('color', this.mainContentColor)
        description2.setAttribute('value', 'According to an investigative report by the Fourth Estate and the Media Foundation for West Africa (MFWA), the National Lottery Authority (NLA) gave away a GHS 3 billion prime business to KGL Technology Limited in exchange for peanuts of GHs 170 million annually.')
        description2.setAttribute('font-size', 0.05);
        description2.setAttribute('scale', '0.25 0.25 0.25');
        description2.setAttribute('anchor', 'left');
        description2.setAttribute('baseline', 'top');
        description2.setAttribute('position', `0 -0.4 0.001`)
        // description2.setAttribute('max-width', 1.1)
        description2.setAttribute('width', 4.2)
        description2.setAttribute('wrapCount', 33.6)
        description2.setAttribute('line-height', 60)
        this.contentElementS2.appendChild(description2);

        const reedFullArticleContainer = document.createElement('a-entity');
        reedFullArticleContainer.setAttribute('position', `0.55 -1.55 0.0`);

        const reedFullArticleButton = document.createElement('ui-button');
        reedFullArticleButton.setAttribute('label', 'Read full article');
        reedFullArticleButton.setAttribute('type', 'rounded-box');
        reedFullArticleButton.setAttribute('width', 1.1);
        reedFullArticleButton.setAttribute('height', 0.14);
        reedFullArticleButton.setAttribute('depth', 0.01);
        reedFullArticleButton.setAttribute('radius', 0.02);
        reedFullArticleButton.setAttribute('color-scheme', 'accent');
        reedFullArticleButton.setAttribute('preferred-font-size', 0.04);
        reedFullArticleButton.setAttribute('hover-scale', 1);
        reedFullArticleContainer.appendChild(reedFullArticleButton);

        reedFullArticleButton.addEventListener('click', () => {
            if (!this.currentNews || !this.currentNews.url) return
            const scene = document.querySelector('a-scene');
            if (scene && scene.exitVR) {
                scene.exitVR();
            }
            
            if (window.gtag) gtag('event', 'VR_LeftPanel_ClickOnNewsReadFull');

            window.open(this.currentNews.url)
        })

        this.contentElementS2.appendChild(reedFullArticleContainer);
    },

    updateNewsType: function (type) {
        const value = type.detail;
        const newsTypeText = document.querySelector('#left-panel-2 #news-type-text');
        if (newsTypeText) {
            newsTypeText.setAttribute('value', value);
            newsTypeText.setAttribute('color', this.mainContentColor);
        }
        if (this.titleTextS1) {
            if (value && value !== 'BUSINESS') {
                this.lastNewsTitle = value;
                this.titleTextS1.setAttribute('value', value);
            } else {
                this.lastNewsTitle = null;
                this.titleTextS1.setAttribute('value', 'News');
            }
            this.titleTextS1.setAttribute('color', this.mainContentColor);
        }
    },

    updateNewsList: function (inputList) {
        let list = this.lastNewsList
        if (inputList) {
            list = inputList
            this.lastNewsList = inputList
        }

        console.log('updateNewsList', list)

        this.screen1.setAttribute('visible', 'true');
        this.screen1.setAttribute('position', '0 0 0.02');
        this.screen2.setAttribute('visible', 'false');
        this.screen2.setAttribute('position', '0 6 0');

        while (this.contentElementS1.children.length > 1) {
            this.contentElementS1.removeChild(this.contentElementS1.lastChild);
        }

        if (typeof list.detail === 'string') {
            this.informNoArticles(list.detail)
        } else {
            const itemHeight = 0.28;
            const titleRowHeight = 0.14;

            list.detail.forEach((item, index) => {
                if (index > 4 ) return
                this.createNews(item, -(titleRowHeight + index * itemHeight));
            })
        }
    },

    informNoArticles: function(value) {
        const noArticlesElem = document.createElement('a-text');
        noArticlesElem.setAttribute('value', value);
        noArticlesElem.setAttribute('scale', '0.2 0.2 0.2');
        noArticlesElem.setAttribute('align', 'left');
        noArticlesElem.setAttribute('anchor', 'left');
        noArticlesElem.setAttribute('position', `0 -0.1 0.01`)
        noArticlesElem.setAttribute('color', this.mainContentColor);

        this.contentElementS1.appendChild(noArticlesElem);
    },

    createNews: function (news, y) {
        const newsContainer = document.createElement('a-entity');
        newsContainer.setAttribute('position', `0 ${y} 0.01`);

        // source
        const truncatedSource = news.publisher.length > 30
            ? news.publisher.slice(0, news.publisher.lastIndexOf(' ', 30)) + "..."
            : news.publisher;
        const sourceElem = document.createElement('a-text');
        sourceElem.setAttribute('value', this.decodeHtmlEntities(truncatedSource));
        sourceElem.setAttribute('color', this.mainContentColor);
        // sourceElem.setAttribute('font-size', 0.04);
        sourceElem.setAttribute('scale', '0.2 0.2 0.2');
        sourceElem.setAttribute('anchor', 'left');
        // sourceElem.setAttribute('position', `${padding} 0 0.01`)
        newsContainer.appendChild(sourceElem);

        const publishedDate = new Date(news.publishedDate).toLocaleDateString()
        const dateElem = document.createElement('a-text');
        dateElem.setAttribute('value', publishedDate);
        dateElem.setAttribute('color', this.mainContentColor);
        // dateElem.setAttribute('font-size', 0.04);
        dateElem.setAttribute('scale', '0.2 0.2 0.2');
        dateElem.setAttribute('align', 'right');
        dateElem.setAttribute('anchor', 'right');
        dateElem.setAttribute('position', `1.1 0 0.01`)
        newsContainer.appendChild(dateElem);

        // title
        const truncatedTitle = news.title.length > 60
            ? news.title.slice(0, news.title.lastIndexOf(' ', 60)) + "..."
            : news.title;
        const titleElem = document.createElement('a-text');
        titleElem.setAttribute('value', this.decodeHtmlEntities(truncatedTitle));
        titleElem.setAttribute('color', this.mainContentColor);
        // titleElem.setAttribute('font-size', 0.05);
        titleElem.setAttribute('scale', '0.25 0.25 0.25');
        // titleElem.setAttribute('max-width', 0.85);
        titleElem.setAttribute('width', 3.5)
        titleElem.setAttribute('wrap-count', 28)
        titleElem.setAttribute('line-height', 60)
        titleElem.setAttribute('anchor', 'left');
        titleElem.setAttribute('baseline', 'top');
        titleElem.setAttribute('position', `0 -0.06 0.001`)
        newsContainer.appendChild(titleElem);

        const titleInteractiveArea = document.createElement('a-plane');
        titleInteractiveArea.setAttribute('width', `0.9`)
        titleInteractiveArea.setAttribute('height', `0.2`)
        titleInteractiveArea.setAttribute('opacity', `0`)
        titleInteractiveArea.setAttribute('material', `depthTest : false`)
        titleInteractiveArea.setAttribute('data-raycastable', ``)
        titleInteractiveArea.setAttribute('position', `0.45 ${-0.04 - 0.1} 0.002`)
        newsContainer.appendChild(titleInteractiveArea);

        titleInteractiveArea.addEventListener('mouseenter', () => {
            titleElem.setAttribute('animation__color', {
                property: 'color',
                to: '#6C6CFF',
                dur: 400,
                easing: 'easeInOutQuad'
            });
        });
        titleInteractiveArea.addEventListener('mouseleave', () => {
            titleElem.setAttribute('animation__color', {
                property: 'color',
                to: this.mainContentColor,
                dur: 400,
                easing: 'easeInOutQuad'
            });
        });
        titleInteractiveArea.addEventListener('click', openNews.bind(this));

        const reedFullButton = document.createElement('a-text');
        reedFullButton.setAttribute('value', 'Read');
        reedFullButton.setAttribute('color', this.mainContentColor);
        // reedFullButton.setAttribute('font-size', 0.045);
        reedFullButton.setAttribute('scale', '0.225 0.225 0.225');
        reedFullButton.setAttribute('anchor', 'right');
        reedFullButton.setAttribute('align', 'right');
        reedFullButton.setAttribute('baseline', 'top');
        reedFullButton.setAttribute('position', `1.03 -0.095 0.002`)
        newsContainer.appendChild(reedFullButton);

        const readFullBg = document.createElement('a-rounded-plane');
        readFullBg.setAttribute('width', `0.2`)
        readFullBg.setAttribute('height', `0.1`)
        readFullBg.setAttribute('radius', `0.016`)
        // readFullBg.setAttribute('opacity', `0.02`)
        readFullBg.setAttribute('color', this.themeMode === 'Dark' ? '#333' : '#DDD')
        readFullBg.setAttribute('position', `0.9 -0.16 0.001`)
        newsContainer.appendChild(readFullBg);

        const bookIcon = document.createElement('a-image');
        bookIcon.setAttribute('src', '#book-icon');
        bookIcon.setAttribute('width', 0.05);
        bookIcon.setAttribute('height', 0.05);
        bookIcon.setAttribute('transparent', true);
        // bookIcon.setAttribute('material', `depthTest : false`)
        bookIcon.setAttribute('position', `1.06 ${-0.06 - 0.05} 0.002`)
        let imageColor = this.themeMode === 'Dark' ? '#FFFFFF' : '#14141C';
        bookIcon.setAttribute('material', 'color', imageColor);
        newsContainer.appendChild(bookIcon);

        const readFullInteractiveArea = document.createElement('a-plane');
        readFullInteractiveArea.setAttribute('width', `0.2`)
        readFullInteractiveArea.setAttribute('height', `0.1`)
        readFullInteractiveArea.setAttribute('opacity', `0`)
        readFullInteractiveArea.setAttribute('material', `depthTest: false`)
        readFullInteractiveArea.setAttribute('data-raycastable', ``)
        readFullInteractiveArea.setAttribute('position', `1.04 ${-0.06 - 0.05} 0.002`)
        newsContainer.appendChild(readFullInteractiveArea);

        readFullInteractiveArea.addEventListener('mouseenter', () => {
            console.log('enter', reedFullButton)
            readFullBg.setAttribute('animation__color', {
                property: 'color',
                to: this.themeMode === 'Dark' ? '#666' : '#CCC',
                dur: 200,
                easing: 'easeInOutQuad'
            });
        });

        readFullInteractiveArea.addEventListener('mouseleave', () => {
            readFullBg.setAttribute('animation__color', {
                property: 'color',
                to: this.themeMode === 'Dark' ? '#333' : '#DDD',
                dur: 200,
                easing: 'easeInOutQuad'
            });

        });
        readFullInteractiveArea.addEventListener('click', openNews.bind(this))


        this.contentElementS1.appendChild(newsContainer);


        function openNews() {
            console.log('openNews', news)
            this.screen1.setAttribute('visible', 'false');
            this.screen1.setAttribute('position', '0 6 0');
            this.screen2.setAttribute('visible', 'true');
            this.screen2.setAttribute('position', '0 0 0.04');

            this.currentNews = news;
            this.fillNewsData();

            if (window.gtag) gtag('event', 'VR_LeftPanel_ClickOnNewsExpand');
        }
    },

    fillNewsData: function () {
        console.log('fillNewsData', this.currentNews)

        const newsType = this.el.querySelector('#news-screen-2 #news-type-text-2');
        const newsDate = this.el.querySelector('#news-screen-2 #news-date-text-2');
        const newsTitle = this.el.querySelector('#news-screen-2 #news-title-text-2');
        const newsSource = this.el.querySelector('#news-screen-2 #news-source-text-2');
        const newsDescription = this.el.querySelector('#news-screen-2 #news-description-text-2');
        console.log('elements', newsType, newsDate, newsTitle, newsSource, newsDescription)

        newsType.setAttribute('value', this.currentNews.tickers[0]);
        newsDate.setAttribute('value', new Date(this.currentNews.publishedDate).toLocaleDateString());
        newsTitle.setAttribute('value', this.decodeHtmlEntities(this.currentNews.title));
        newsSource.setAttribute('value', `By ${this.decodeHtmlEntities(this.currentNews.publisher)}`);

        const finalDescription = this.currentNews.description.length > 400
            ? this.currentNews.description.slice(0, this.currentNews.description.lastIndexOf(' ', 400)) + "..."
            : this.currentNews.description;
        newsDescription.setAttribute('value', this.decodeHtmlEntities(finalDescription));
    },

    decodeHtmlEntities: function (str) {
        const parser = new DOMParser();
        const decoded = parser.parseFromString(str, "text/html");
        return decoded.documentElement.textContent;
    },

    updateTheme: function (e) {
        console.log('updateTheme', e)
        if (!e || !e.detail) return;
        this.themeMode = e.detail.themeMode;
        this.applyTheme()

        this.headerElementS1.innerHTML = ''
        this.headerElementS2.innerHTML = ''
        this.contentElementS1.innerHTML = ''
        this.contentElementS2.innerHTML = ''
        this.createNewsPanel();

        const tickerNewsEl = this.el.sceneEl.querySelector('[ticker-news]');
        const currentFilter = tickerNewsEl ? tickerNewsEl.components['ticker-news']?.currentFilter : 'general';
        this.setFilter(currentFilter || 'general');

        // Restore title: only update color, keep the last known title text
        if (this.titleTextS1) {
            if (this.lastNewsTitle) {
                this.titleTextS1.setAttribute('value', this.lastNewsTitle);
            }
            this.titleTextS1.setAttribute('color', this.mainContentColor);
        }

        this.updateNewsList()
    },

    setFilter: function(filter) {
        if (!this.generalBtn || !this.watchlistBtn) return;

        if (filter === 'general') {
            this.generalBtn.setAttribute('ui-button', 'selected', true);
            this.watchlistBtn.setAttribute('ui-button', 'selected', false);
        } else if (filter === 'watchlist') {
            this.watchlistBtn.setAttribute('ui-button', 'selected', true);
            this.generalBtn.setAttribute('ui-button', 'selected', false);
        }
    }
})
